import { memo } from "react";
import { Box, Typography } from "@mui/material";


const OrderFooter = ({ customerInfo, orderData }) => {
  // Calculate points redeemed from reward transactions
  const pointsRedeemed = orderData?.metadata?.transactions?.reduce((total, transaction) => {
    if (transaction?.tender?.method === 'reward' && transaction?.rewardPoints) {
      return total + (transaction.rewardPoints || 0);
    }
    return total;
  }, 0) || 0;

  // Extract points earned from charges
  const pointsEarned = orderData?.charges?.earnedRewardPoints || 0;

  // Calculate total balance (this might need to be provided from customer data or calculated differently)
  // For now, using a simple calculation based on available data
  // const currentRewardPoints = orderData?.charges?.rewardPoints || 0;
  // const totalBalance = currentRewardPoints + pointsEarned;

  // Show points section if any points data exists
  const showPointsInfo = pointsRedeemed > 0 || pointsEarned > 0;

  return (
    <Box
      style={{
        textAlign: 'center',
      }}
    >
      {/* Points Information Section */}
      {showPointsInfo && (
        <Box style={{ marginBottom: '24px' }}>
          {pointsRedeemed > 0 && (
            <Box className="delivery-wrapper" style={{ marginBottom: '4px' }}>
              <Typography className="payment-title">
                Points redeemed:&nbsp;
              </Typography>
              <Typography className="payment-title">
                {pointsRedeemed.toLocaleString()} pts
              </Typography>
            </Box>
          )}
          {pointsEarned > 0 && (
            <Box className="delivery-wrapper" style={{ marginBottom: '4px' }}>
              <Typography className="payment-title">
                Points earned on this order:&nbsp;
              </Typography>
              <Typography className="payment-title">
                {pointsEarned.toLocaleString()} pts
              </Typography>
            </Box>
          )}
          {/* {totalBalance > 0 && (
            <Box className="delivery-wrapper" style={{ marginBottom: '4px' }}>
              <Typography className="payment-title">
                Total balance:&nbsp;
              </Typography>
              <Typography className="payment-title">
                {totalBalance.toLocaleString()} pts
              </Typography>
            </Box>
          )} */}
          <hr className="line-header" style={{ marginTop: '12px' }} />
        </Box>
      )}

      {/* Thank You Message */}
      {customerInfo?.firstName ? (
        <Box className="uppercase">
          <Typography className="thankYou-text">
            {`Thank you for your order, ${customerInfo?.firstName} ${customerInfo?.lastName?.charAt(0) || ''}!`}
          </Typography>
          <Typography className="thankYou-text-second">It was a pleasure serving you.</Typography>
          <Typography className="thankYou-text-second">Have a nice day!</Typography>
        </Box>
      ) : (
        <Box className="uppercase">
          <Typography className="thankYou-text">
            {`Thank you for your order!`}
          </Typography>
          <Typography className="thankYou-text-second">It was a pleasure serving you.</Typography>
          <Typography className="thankYou-text-second">Have a nice day!</Typography>
        </Box>
      )}
    </Box>
  )
}

export default memo(OrderFooter)